var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _c(
        "emd-card",
        { staticClass: "_footer_end" },
        [
          _c(
            "emd-card-header",
            [
              _c("emd-text", { attrs: { tag: "h2" } }, [
                _vm._v(_vm._s(_vm.$t("invite.create.title"))),
              ]),
            ],
            1
          ),
          _c(
            "emd-card-content",
            { attrs: { customClass: "eu-no-padding" } },
            [
              _vm.roles.length === 0
                ? _c(
                    "div",
                    { staticClass: "eu-pa_6 eu-align_center" },
                    [_c("emd-loader", { attrs: { type: "_invert" } })],
                    1
                  )
                : _c("form-invite-create"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }